import { AfterViewInit, Component, OnDestroy, OnInit } from '@angular/core';
import { CommonDataDTO } from '../model/combos-model';
import { RequestPanelStore } from '../@shared/request-panel/request-panel.store';
import { ActivatedRoute, Router, UrlTree } from '@angular/router';
import { dataPrint, OperationsQueryDto } from '../model/requests-model';
import jsPDF from 'jspdf';
import autoTable from 'jspdf-autotable';
import { ExcelService } from '@app/@shared/services/print/excel.service';
import { PanelStore } from './panel.store';
import { CombosStore } from '../combos-service/combos.store';
import { Deactivate } from '@app/@core/guards/can-deactivate.guard';
import { Observable } from 'rxjs';
import { AuthenticationService } from '@app/login';
import { MultilevelMenuService } from 'ng-material-multilevel-menu';
import { LoaderGenericService } from '@app/@shared/loader-generic/loader-generic.service';
import {
  REQUEST_APPROVED,
  REQUEST_CANCELLED,
  REQUEST_CONDTIONATED_VALIDATION,
  REQUEST_DENIED,
  REQUEST_PENDING,
  REQUEST_PENDING_PAYMENT_INCIDENT,
  REQUEST_REGULARISE_PAID_VALIDATED,
  REQUEST_SIGNED,
  REQUEST_STUDYING,
  REQUEST_CONDITIONED_PENDING_FORMALIZATION,
} from '@app/@core/constants/requests.constants';
import { TranslateService } from '@ngx-translate/core';
import FileSaver from 'file-saver';
import moment from 'moment';

@Component({
  selector: 'app-panel',
  templateUrl: './panel.component.html',
  styleUrls: ['./panel.component.scss'],
})
export class PanelComponent implements OnInit, AfterViewInit, OnDestroy, Deactivate {
  isSearchViewChanged: boolean = false;

  public statusRequests: CommonDataDTO[] = [];

  public searchParams: OperationsQueryDto;
  public isMainPanel: boolean = true;
  public isFilter: boolean = false;
  public titleSingleView: string;

  public currentState: OperationsQueryDto;
  public keepFilter: boolean = false;

  public allData: any[] = [];
  public allDataExport: any[] = [];
  private head = [
    'request.numberRequest',
    'request.firstUpdate',
    'request.lastUpdate',
    'request.nameClient',
    'request.seller',
    'request.prod',
    'request.pro',
    'request.financed',
  ];

  private isRequestLoaded: boolean = false;
  private isComponentLoaded: boolean = false;
  private isSearchLoaded: boolean = false;

  constructor(
    private combosStore: CombosStore,
    private requestPanelStore: RequestPanelStore,
    private panelStore: PanelStore,
    private excelService: ExcelService,
    private loaderGenericService: LoaderGenericService,
    public route: ActivatedRoute,
    private translateService: TranslateService
  ) {
    this.loaderGenericService.showSpinner();
  }

  ngAfterViewInit(): void {
    this.isComponentLoaded = true;
    this.changeStateLoading();
  }

  updateStatusPanel(): boolean | UrlTree | Observable<boolean | UrlTree> | Promise<boolean | UrlTree> {
    this.panelStore.setFilterStatus(this.currentState);
    return true;
  }

  ngOnDestroy(): void {}

  ngOnInit(): void {
    this.route.params.subscribe((params) => {
      this.keepFilter = params['keepFilter'];
    });

    if (!this.keepFilter) {
      //clean filters
      this.panelStore.setFilterStatus({ state: 'TS', initialDate: '', finalDate: '' });
    }

    //Load Combo Status Requests
    this.combosStore
      .loadStatusRequests()
      .then(() => {
        this.combosStore.statusRequestsList$.subscribe(
          (statusRequestsList) => {
            if (statusRequestsList) {
              const orderStatus = [
                REQUEST_PENDING,
                REQUEST_STUDYING,
                REQUEST_APPROVED,
                REQUEST_SIGNED,
                REQUEST_REGULARISE_PAID_VALIDATED,
                REQUEST_PENDING_PAYMENT_INCIDENT,
                REQUEST_DENIED,
                REQUEST_CANCELLED,
                REQUEST_CONDITIONED_PENDING_FORMALIZATION,
              ];
              this.statusRequests = statusRequestsList.sort(
                (a, b) => orderStatus.indexOf(a.id) - orderStatus.indexOf(b.id)
              );
            }
          },
          (error) => console.error(error)
        );

        //Load status
        this.currentState = this.panelStore.getFilterStatus();

        if (this.currentState.state === 'TS') {
          this.requestPanelStore.loadOperationPanel();
        } else {
          this.changeView(this.currentState);
        }
      })
      .catch(() => (this.isRequestLoaded = true))
      .finally(() => {
        this.isSearchLoaded = true;
        this.changeStateLoading();
      });

    //Reload combos when change language
    this.translateService.onLangChange.subscribe((event) => {
      this.combosStore
        .loadStatusRequests()
        .then(() => {
          this.changeView(this.currentState);
        })
        .catch(() => (this.isRequestLoaded = true))
        .finally(() => {
          this.isSearchLoaded = true;
          this.changeStateLoading();
        });
    });
  }

  public changeView(searchParameters: OperationsQueryDto) {
    if (searchParameters?.state !== 'TS') {
      this.isMainPanel = false;
      this.isFilter = true;
    } else {
      this.allData = [];
      this.isRequestLoaded = false;
      this.loaderGenericService.showSpinner();
      this.requestPanelStore.loadOperationPanel();
      this.isMainPanel = true;
      this.isFilter = false;
      this.titleSingleView = '';
    }

    this.titleSingleView = searchParameters.state;
    this.searchParams = searchParameters;
    this.currentState = searchParameters;
  }

  public updateView(stateId: string) {
    console.log('update view, stateid: ', stateId, this.currentState);
    let updateCurrentState = {
      state: stateId,
      initialDate: this.currentState.initialDate,
      finalDate: this.currentState.finalDate,
    };
    this.currentState = updateCurrentState;
    this.isMainPanel = false;
    this.titleSingleView = stateId;
  }

  loadAllData(data: any) {
    console.log('loadAllData panel', data);
    //TODO: change to id when it's changed in origin component
    if (data.state !== 'TS') {
      this.allData.push(data);
    }
  }

  viewRequest(numRequest: any) {
    this.panelStore.setFilterStatus(this.currentState);
    //TODO: REVISAR
    //this.router.navigate(['requests/request-show-edit', { request: numRequest }], { replaceUrl: false });
  }

  createAllPdf() {
    let dataPdf: any[] = [];
    let print: any;
    let startTable = 80;
    let startState = 75;
    let startHeader = 50;

    const date = moment().locale('es');
    const filename = 'Ultimas_operaciones_' + date.format('DDMMYYYY');

    let doc = new jsPDF();
    doc.setProperties({
      title: 'Últimas operaciones',
    });

    var img = new Image();
    img.src = 'assets/img/logo.PNG';
    doc.addImage(img, 'png', 3, 10, 80, 30);
    doc.text('Listado de las últimas operaciones', 14, 45);
    doc.setFontSize(13);

    autoTable(doc, {
      startY: startHeader,
      head: [this.head.map((header) => this.translateService.instant(header))],
      body: [],
      styles: {
        fillColor: '#969696',
      },
    });

    this.allData.forEach((item, index) => {
      console.log(item);
      if (item.data.data) {
        print = item.data.data;
      } else {
        print = item.data;
      }
      print.map((data: any) => {
        const {
          digitalSignature,
          digitalSignatureFlag,
          ine,
          numCon,
          print,
          printCode,
          finacialProduct,
          sendAsync,
          ...datae
        } = data;
        const dataPdfOrder = JSON.stringify(datae, [
          'numOperation',
          'dateEntry',
          'dateStatus',
          'nameHolder',
          'nameVendor',
          'prod',
          'prot',
          'financed',
        ]);

        const ObjectDataPdf = JSON.parse(dataPdfOrder);
        dataPdf.push(ObjectDataPdf);
      });

      if (index === 2 || index === 4 || index === 6) {
        doc.addPage();
        startTable = 30;
        startState = 25;
      }

      doc.text(this.translateService.instant(item.state), 14, startState);

      console.log(item);

      autoTable(doc, {
        startY: startTable,
        head: [],
        body: dataPdf,
      });

      dataPdf = [];
      startTable = startTable + 100;
      startState = startState + 100;
    });

    var blob = doc.output('blob');
    FileSaver.saveAs(blob, filename);
    window.open(URL.createObjectURL(blob));
  }

  createAllExcel() {
    let dataExcelPrint: any[] = [];
    let allDataExcel: dataPrint[] = [];
    let print: any;
    allDataExcel = this.allData;
    const date = moment().locale('es');
    const filename = 'Ultimas_operaciones_' + date.format('DDMMYYYY');
    this.allData.forEach((item, index) => {
      if (item.data.data) {
        print = item.data.data;
      } else {
        print = item.data;
      }
      print.map((data: any) => {
        if (data.dateStatus === null) {
          data.dateStatus = '';
        } else if (!data.dateStatus) {
          data.dateStatus = '';
        }
        const {
          digitalSignature,
          digitalSignatureFlag,
          ine,
          numCon,
          print,
          printCode,
          finacialProduct,
          sendAsync,
          ...dataExcel
        } = data;
        const dataExcelOrder = JSON.stringify(dataExcel, [
          'numOperation',
          'dateEntry',
          'dateStatus',
          'nameHolder',
          'nameVendor',
          'prod',
          'prot',
          'financed',
        ]);

        const ObjectDataExcel = JSON.parse(dataExcelOrder);
        dataExcelPrint.push(ObjectDataExcel);
      });

      allDataExcel[index].data = dataExcelPrint;
      dataExcelPrint = [];
    });

    const excelAllData = {
      fileName: filename,
      headers: this.head.map((header) => this.translateService.instant(header)),
      data: allDataExcel,
    };
    this.excelService.exportExcelAll(excelAllData);
  }

  public changeRequestsState(value: boolean): void {
    this.isRequestLoaded = value;
    this.changeStateLoading();
  }

  private changeStateLoading(): void {
    this.isRequestLoaded && this.isComponentLoaded && this.isSearchLoaded
      ? this.loaderGenericService.stopSpinner()
      : this.loaderGenericService.showSpinner();
  }

  onChangeSearchView(value: boolean) {
    this.isSearchViewChanged = value;
    if (this.isSearchViewChanged) {
      this.currentState.state = 'S';
      this.changeView(this.currentState);
    }
  }
}
